
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class RefundExpireConfField extends Vue {
  val: number | string = 1;

  @Prop()
  placeholder?: string;

  @Prop()
  refs!: any;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  type: 'day' | 'time' = 'day';

  @Model('change', {
    type: String,
  })
  value!: any;

  @Watch('val')
  watchInternalVal() {
    this.$emit('change', `${this.type}:${this.val}`);
  }

  @Watch('value')
  watchValue() {
    console.log('watchValue', this.value);
    if (this.value.includes('day:')) {
      this.type = 'day';
      this.val = this.value.split(':')[1];
    }
  }

  mounted() {
    this.watchValue();
  }
}
